var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPopInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1564 12.6016C19.1112 12.6016 20.0268 12.9808 20.702 13.656C21.3771 14.3311 21.7564 15.2468 21.7564 16.2016V28.8016C21.7564 29.7563 21.3771 30.672 20.702 31.3471C20.0268 32.0223 19.1112 32.4016 18.1564 32.4016C17.2016 32.4016 16.2859 32.0223 15.6108 31.3471C14.9357 30.672 14.5564 29.7563 14.5564 28.8016V16.2016C14.5564 15.2468 14.9357 14.3311 15.6108 13.656C16.2859 12.9808 17.2016 12.6016 18.1564 12.6016Z",
    fill: "#CF9D61"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7564 7.20156C21.7564 8.15634 21.3771 9.07202 20.702 9.74715C20.0268 10.4223 19.1112 10.8016 18.1564 10.8016C17.2016 10.8016 16.2859 10.4223 15.6108 9.74715C14.9357 9.07202 14.5564 8.15634 14.5564 7.20156C14.5564 6.24678 14.9357 5.33111 15.6108 4.65598C16.2859 3.98085 17.2016 3.60156 18.1564 3.60156C19.1112 3.60156 20.0268 3.98085 20.702 4.65598C21.3771 5.33111 21.7564 6.24678 21.7564 7.20156Z",
    fill: "#CF9D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopInfo);
export default __webpack_public_path__ + "static/media/pop_info.15b16d439e1e23040f94ac8ea47a6a83.svg";
export { ForwardRef as ReactComponent };